(function () {
  'use strict';

  /* Reveal on scroll */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('rdc-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.rdc-reveal').forEach(function (el) { io.observe(el); });

  var form = document.getElementById('rdc-reserva-form');
  if (!form) return;

  var select = form.querySelector('#rdc-tipo');
  var depositEl = form.querySelector('#rdc-deposit-amount');
  var btn = form.querySelector('#rdc-submit');
  var msg = form.querySelector('#rdc-msg');

  function syncDeposit() {
    var opt = select.options[select.selectedIndex];
    if (opt && depositEl) depositEl.textContent = opt.dataset.price || '';
  }

  /* Preselect variant from ?tipo=mesa|evento|catering so links can jump straight to the right option */
  (function preselectFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var tipo = params.get('tipo');
    if (!tipo) return;
    var keywords = { mesa: 'mesa', evento: 'evento', catering: 'catering' };
    var keyword = keywords[tipo.toLowerCase()] || tipo.toLowerCase();
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].textContent.toLowerCase().indexOf(keyword) !== -1) {
        select.selectedIndex = i;
        break;
      }
    }
  })();

  select.addEventListener('change', syncDeposit);
  syncDeposit();

  function showMsg(text, isError) {
    msg.textContent = text;
    msg.classList.toggle('rdc-msg--error', !!isError);
    msg.classList.add('rdc-show');
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    msg.classList.remove('rdc-show');

    var data = new FormData(form);
    var variantId = parseInt(select.value, 10);
    if (!variantId) { showMsg('Selecciona el tipo de experiencia.', true); return; }

    var properties = {
      'Tipo de experiencia': select.options[select.selectedIndex].text,
      'Fecha del evento': data.get('fecha'),
      'Hora': data.get('hora'),
      'Personas': data.get('personas'),
      'Nombre': data.get('nombre'),
      'WhatsApp': data.get('telefono')
    };
    if (data.get('comentarios')) properties['Comentarios'] = data.get('comentarios');

    btn.disabled = true;
    btn.textContent = 'Procesando…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart } }));
        showMsg('Reserva agregada. Completa el pago del anticipo para confirmar tu fecha.');
        btn.disabled = false;
        btn.textContent = 'Reservar y pagar anticipo';
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') { drawer.open(); }
        else { window.location.href = '/cart'; }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Reservar y pagar anticipo';
        showMsg('No pudimos agregar tu reserva. Intenta de nuevo o escríbenos por WhatsApp.', true);
      });
  });
})();